<template>
    <div class="newsDetails">
        <newsHeaders :title="$i18n.locale=='zh'?newsData.title_zh: newsData.title_en" :url="newsDataSrc" :newsBrand="$i18n.locale=='zh'?  newsData.source_zh: newsData.source_en" :date="newsData.date" img="newsCenter"></newsHeaders>
        <div class="goBack">
            <div class="backBtns" @click="goBack()">
                <img src="../../public/img/whiteLeft.png" alt="" srcset="">
                <div>{{$t('返回上一级')}}</div>
            </div>
        </div>
        <div class="line"></div>
        <div class="newsDetailsInfo" v-for="(item, index) in newsData.info" :key="index">
            <img v-if="item.type=='图片'" :src="`${item.image_url}`" width="100%" alt="" srcset="">
            <video v-else-if="item.type=='video'" width="100%"  controls="controls">
                <source :src="`${item.image_url}`" type="video/mp4" />
            </video>
            <div  class="text" v-else-if="item.type=='文本'">{{$i18n.locale=='zh'?item.text_zh:item.text_en}}</div>
        </div>

        <div class="line"></div>
        <div class="btnNextAndBefore">
            <!-- <div :class="index==0?'publicBtn null':'publicBtn have'"  @click="gotoBefore()"> -->
            <div class="publicBtn have"  @click="gotoBefore()">
                <div class="img">
                    <img src="../../public/img/whiteLeft.png" height="100%" style="margin-right:0.5rem;" alt="" srcset="">
                </div>
                <div  class="text">{{$t('上一篇')}}</div>
            </div>
            <!-- <div :class="index+1<length?'publicBtn have':'publicBtn null'" @click="gotoNext()"> -->
            <div class="publicBtn have" @click="gotoNext()">
                <div class="text" style="text-align: right;">{{$t('下一篇')}}</div>
                <div class="img">
                    <img src="../../public/img/whiteRight.png" height="100%" style="margin-right:0.5rem;" alt="" srcset="">   
                </div>
            </div>
        </div>        
        <foot style="margin-top:5rem;"></foot>
    </div>
</template>
<script>
import newsHeaders from "@/components/newsHeaders.vue";
import foot from "@/components/foot.vue";
// import {getNewsData} from "../datas/newsData.js"
import {getNewsById,newsNext,newsBefore} from '../datas/ajax'
export default {
    created(){
        this.render()
    },
    data() {
        return {
            baseUrl:process.env.BASE_URL,
            newsData:{},
            index:0,
            length:0
        }
    },
    watch: {
        '$route' (to, from) {
            this.render()
        },
        '$i18n.locale'(){
            this.render()
        },
    },
    computed:{
        newsDataSrc(){
            console.log()
            return this.newsData.src?this.newsData.src:""
        }
    },
    methods: {
        render(){
            this.index = parseInt(this.$route.params.index)
            getNewsById({id:this.index},(data)=>{
                this.newsData = data
            })
            // let data = getNewsData()
            // this.newsData = data[parseInt(this.$route.params.index)]
            // this.length = data.length
        },
        goBack(){
            this.$router.push('/news')
        },
        gotoNext(){
            // if(this.index+1<this.length){
            //     this.$router.push('/newsDetails/'+(this.index+1))
            //     document.getElementById("app").scrollIntoView();
            // }
            newsNext({id:this.index},(data)=>{
                this.$router.push('/newsDetails/'+data)
            })
        },
        gotoBefore(){
            // if(this.index>0){
            //     this.$router.push('/newsDetails/'+(this.index-1))
            //     document.getElementById("app").scrollIntoView();
            // }
            newsBefore({id:this.index},(data)=>{
                this.$router.push('/newsDetails/'+data)
            })
        }
    },
    components:{
        newsHeaders,foot
    }
}
</script>

<style lang="less">
.newsDetails{
    .newsDetailsInfo{
        width: 50%;
        margin: 0.5rem auto;
        .text{
            font-size: 1rem;
            line-height: 1.6rem;
            color: #232323;
        }
        video,img{
            // margin: 2rem auto;
            margin-bottom: 2rem;
        }
    }
    .null{
        background-color: #E5E5E5;
    }
    .have{
        background-color: #22A3C6;
    }
    .btnNextAndBefore{
        width: 50%;
        margin: 2rem auto;
        display: flex;
        font-size: 0.8rem;
        justify-content: space-between;
        align-items: center;
        .publicBtn{
            padding: 5px 1.2rem;
            border-radius: 10rem;
            cursor: pointer;
            display: flex;
            color: #fff;
            align-items: center;
            // justify-content: center;
            width: 15%;
            .img{
                height: 50%;
                margin: 0 10px;
                // display: block;
                // background: gray;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .text{
                width: 90%;
                text-overflow:ellipsis;
                overflow:hidden;
                // display: block;
                // text-align: center;
                // background: red;
                white-space:nowrap; 
            }
        }
    }
    .line{
        width: 100%;
        border-bottom: 1px solid #BFBFBF;
    }
    .goBack{
        width: 60%;
        margin: 0 auto;
        height: 3rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .backBtns{
            background-color: rgba(1, 124, 168, 0.31);
            padding: 5px 1.2rem;
            cursor: pointer;
            display: flex;
            font-size: 0.8rem;
            border-radius: 5rem;
            align-items: center;
            width: fit-content;
            div{
                display: inline-block;
                white-space:nowrap;
                color: #fff;
            }
            img{
                height: 15px;
                margin-right: 5px;
            }
        }
    }
}
</style>
<i18n>
{
    "en": {
        "上一篇":"Previous",
        "下一篇":"Next"
    },
    "zh":{
        "上一篇":"上一篇",
        "下一篇":"下一篇"
        
    }
}
</i18n>

